import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import isTokenValid from './helpers/TokenHelper';

export function useUser() {
  const sessionToken = useSelector(
    (state) => state.authorization?.sessionToken
  );
  const refreshToken = useSelector(
    (state) => state.authorization?.refreshToken
  );

  const userStoredData = useSelector((state) => state.main?.user);

  const isSilentAccount = useSelector(
    (state) => state.authorization?.isSilentAccount ?? false
  );

  const isLoggedIn = useMemo(() => {
    if (sessionToken) return isTokenValid(sessionToken);
    return isTokenValid(refreshToken);
  }, [sessionToken, refreshToken]);

  const userData = useMemo(() => {
    if (isLoggedIn) {
      return userStoredData;
    }

    return null;
  }, [isLoggedIn, userStoredData]);

  return {
    isLoggedIn,
    isSilentAccount,
    userData,
  };
}

export default useUser;
